var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter 1",
    clipPath: "url(#clip0_730_15215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.68057 6.78196L15.4588 0.0652159L15.601 -0.1H15.383H14.0019H13.956L13.9261 -0.0652165L8.95008 5.7189L4.98165 -0.0566311L4.95185 -0.1H4.89923H0.237305H0.0472613L0.154886 0.0566316L6.22352 8.88863L0.161499 15.9348L0.0193562 16.1H0.237305H1.6185H1.66438L1.69431 16.0652L6.95385 9.95148L11.1489 16.0566L11.1787 16.1H11.2313H15.8933H16.0833L15.9757 15.9434L9.68057 6.78196ZM11.9332 14.9075L7.76299 8.94269V8.94235L7.74495 8.91654L7.12565 8.03075L2.30809 1.13974H4.18549L8.13222 6.78525L8.13222 6.78525L8.75152 7.67104L13.8106 14.9075H11.9332Z",
    fill: "#025584",
    stroke: "#025584",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_15215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0654297)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlue);
export default __webpack_public_path__ + "static/media/twitter_blue.8b21830c8604dd6bc2c56c21c98ab0f8.svg";
export { ForwardRef as ReactComponent };